function returnSearchBoxDataSourceUrl(preset) {
    var hotelCityLoadURL = SetUrlWithCulture('/LoadAndFill/HotelCities');
    var trainLoadURL = SetUrlWithCulture('/LoadAndFill/TrainStations');
    var airportsLoadURL = SetUrlWithCulture('/LoadAndFill/Airports');
    var landingLoadURL = SetUrlWithCulture('/LoadAndFill/Landing');
    var insuranceLoadURL = SetUrlWithCulture('/LoadAndFill/InsuranceCountries');
    var hotelLoadURL = SetUrlWithCulture('/LoadAndFill/HotelNames');
    var homeLoadURL = SetUrlWithCulture('/LoadAndFill/Home');
    var url = '';

    switch (preset) {
        case 'airport':
            url = airportsLoadURL;
            break;
        case 'train':
            url = trainLoadURL;
            break;
        case 'city':
            url = hotelCityLoadURL;
            break;
        case 'country':
            url = insuranceLoadURL;
            break;
        case 'hotel':
            url = hotelLoadURL;
            break;
        case 'landing':
            url = landingLoadURL;
            break;
        case 'home':
            url = homeLoadURL;
            break;
    }

    return url;
}
function onSearchBoxInit(inst, elem, options) {
    var parent = $(options.popupContainer);
    var value = parent.find('input[type=hidden].searchbox-value').val();
    var data = storagehandler("load", options.storageKey);
    if (data != undefined && !value && options.storageKey) {
        parent.find(".searchbox-title").html(data.title).data("text", data.text);
        parent.find('input[type=hidden].searchbox-text').val(data.title);
        parent.find('input[type=hidden].searchbox-value').val(data.value);
    }

    if (value == "" && data == undefined) {
        parent.parents(".c-search-fields__first-item,.c-search-fields__second-item").addClass('input-is-empty');
    } else {
        parent.parents(".c-search-fields__first-item,.c-search-fields__second-item").removeClass('input-is-empty');
    }
}
function onSearchBoxSwapperClick(button, options) {
    var parent = button.closest(".c-search-fields-wrapper");
    if (parent.hasClass("flight") ||
        parent.hasClass("flighthotel") ||
        parent.hasClass("train")) {

        var left = parent.find(".SearchBoxLeft"); //hardcoded
        var right = parent.find(".SearchBoxRight"); //hardcoded

        var _title = left.find(".searchbox-title").html();
        var _text = left.find("input.searchbox-text").val();
        var _value = left.find("input.searchbox-value").val();

        var title = right.find(".searchbox-title").html();
        var text = right.find("input.searchbox-text").val();
        var value = right.find("input.searchbox-value").val();

        left.find(".searchbox-title").html(title);
        left.find("input.searchbox-text").val(text);
        left.find("input.searchbox-value").val(value);
        var datal = { title: title, text: text, value: value };
        if (left.data("storagekey")) {
            storagehandler("save", left.data("storagekey"), datal);
            left.parents(".c-search-fields__first-item,.c-search-fields__second-item").removeClass('input-is-empty');
        }

        right.find(".searchbox-title").html(_title);
        right.find("input.searchbox-text").val(_text);
        right.find("input.searchbox-value").val(_value);
        var datar = { title: _title, text: _text, value: _value };
        if (right.data("storagekey")) {
            storagehandler("save", right.data("storagekey"), datar);
            right.parents(".c-search-fields__first-item,.c-search-fields__second-item").removeClass('input-is-empty');
        }

        //correct to default "source" or "destination" if empty
        if (right.find("input.searchbox-value").val() === "") {
            right.find(".searchbox-title").html(right.find(".searchbox-title").data("placeholder"));
            right.parents(".c-search-fields__first-item,.c-search-fields__second-item").addClass('input-is-empty');
        }
        if (left.find("input.searchbox-value").val() === "") {
            left.find(".searchbox-title").html(left.find(".searchbox-title").data("placeholder"));
            left.parents(".c-search-fields__first-item,.c-search-fields__second-item").addClass('input-is-empty');
        }
    }
    loadPrices("-", "-");
}
function onSearchBoxSelectedChanged(inst, elem, item) {
    var localStorageTripType = localStorage.getItem("travel-passengers-flight-triptype");
    var isOneWayTrip = localStorageTripType == null ? (mobileAndTabletCheck() ? $(".flightType.active label").text() == "یک طرفه" : $("#TripType").val() == "OneWay") : JSON.parse(localStorageTripType).content[0].items[0].checked;

    if (isOneWayTrip)//when one-way is selected
    {
        if ($(elem).attr("id").endsWith("Source"))
            loadPrices(item.data("value"), "-");
        else if ($(elem).attr("id").endsWith("Destination"))
            loadPrices("-", item.data("value"));
    }
   
    var title = item.data("text");
    var text = item.data("text"); //todo: text also should be saved
    var value = item.data("value");
    var comma = item.data("comma");
    var shortdesc = item.data("shortdesc");
    title = (shortdesc != undefined && shortdesc !== "") ? (title + comma + " " + shortdesc) : title;

    var container = $(inst.options.popupContainer);
    container.find(".searchbox-title").html(title).data("title", title);
    container.find('input[type=hidden].searchbox-text').val(title);
    container.find('input[type=hidden].searchbox-value').val(value);

    var data = { title: title, text: text, value: value };
    if (inst.options.storageKey) {
        storagehandler("save", inst.options.storageKey, data);
    }
    container.parents(".c-search-fields__first-item,.c-search-fields__second-item").each(function () {
        $(this).removeClass("input-is-empty");
    });
}
function onScrollTopSearchBox(scroll) {
    if ($(scroll).length > 0 && $(scroll).offset().top > 400 && window.innerHeight < 1075) { window.scrollTo({ top: 200, behavior: 'smooth' }) };
}
function isMobile() {
    var check = false;
    (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}
function onSearchBoxAfterShow(inst, elem) {
    if (isMobile()) {
        setTimeout(function () {
            if ($(".searchbox-popup").length > 0) {
                $('body').css('overflow', 'hidden')
            }
        }, 200)
    } 
    var container = $(inst.options.popupContainer);
    var title = container.find(".searchbox-title").data("title");
    container.find('input[type=text]').val(title);
    if ($("#FlightSearchSegments_0__Source-container > div").length > 0 && $("#FlightSearchSegments_0__Source-container > div").offset().top > 400 && window.innerHeight < 1077) { window.scrollTo({ top: 200, behavior: 'smooth' }) };
    onScrollTopSearchBox("#FlightSearchSegments_0__Source-container > div")
    onScrollTopSearchBox("#HotelHiddenDestination-container > div")
    onScrollTopSearchBox("#Flight_Source-container > div")
    onScrollTopSearchBox("#DomesticTrainSource-container > div")
    onScrollTopSearchBox("#InsHiddenDestination-container > div")

    $("#search-switch-btn").click(function () {
        $("#search-switch-btn").toggleClass("on");
        $(".searchbox.searchbox-result").toggleClass("d-none");
    })
}
function onSearchBoxClear(inst, elem) {
    var container = $(inst.options.popupContainer);
    container.find(".searchbox-title").html(inst.options.inputPlaceHolder).data("title", "");
    container.find('input[type=hidden].searchbox-text').val("");
    container.find('input[type=hidden].searchbox-value').val("");

    container.parents(".c-search-fields__first-item,.c-search-fields__second-item").addClass('input-is-empty');
}
function onSearchBoxBeforeShow(inst) {
    var container = $(inst.options.popupContainer);
 
    container.closest('.c-search-fields__field-group').find('.c-search-field__border').addClass("border__blue");   
    container.closest('.c-search-fields__field-group2').find('.c-search-field__border').addClass("border__blue");
}
function onSearchBoxClose(inst) {
    var container = $(inst.options.popupContainer);
    container.closest('.c-search-fields__field-group').find('.c-search-field__border').removeClass("border__blue");
    container.closest('.c-search-fields__field-group2').find('.c-search-field__border').removeClass("border__blue");
}
